<app-vvr-icon [full]="false" [dark]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Inspecties</h1>
        </div>
        <div class="controls">
            <div
                    class="fab small"
                    id="btn-Exit"
                    routerLink="/"
                 matTooltip="Terug naar overzicht"
                 matTooltipPosition="below">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>
    <div class="row justify-content-center mb-3">
        <div class="col-12 col-lg-11">
            <div class="pb-3">
                Gebruik de VVR app voor het invullen van inspectielijsten.
            </div>
            <div>
                <button color="primary" mat-raised-button (click)="chooseChecklist()">
                    Nieuwe inspectie
                </button>
                @if (AuthorisationService.hasFeature('checklistAnswersShowAll')) {
                    <mat-checkbox
                        (change)="getAnswers()"
                        (ngModelChange)="showAll.set($event)"
                        [ngModel]="showAll()"
                        class="ms-3">
                        Toon alle inspecties
                    </mat-checkbox>
                }
            </div>
            <div class="pt-3">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th (click)="sortList(adTypeSortFunction)" class="curpoint" matRipple>
                                <div class="d-flex">
                                    Checklist
                                    <app-sorting-icon [currentSort]="currentSort()" [desc]="desc()" [property]="adTypeSortFunction" class="ms-1"></app-sorting-icon>
                                </div>
                            </th>
                            <th (click)="sortList('worknumber')" class="curpoint" matRipple>
                                <div class="d-flex">
                                    Werknummer
                                    <app-sorting-icon [currentSort]="currentSort()" [desc]="desc()" class="ms-1" property="worknumber"></app-sorting-icon>
                                </div>
                            </th>
                            <th (click)="sortList(foremanSortFunction)" class="d-none d-md-table-cell curpoint" matRipple>
                                <div class="d-flex">
                                    Voorman
                                    <app-sorting-icon [currentSort]="currentSort()" [desc]="desc()" [property]="foremanSortFunction" class="ms-1"></app-sorting-icon>
                                </div>
                            </th>
                            <th (click)="sortList(inspectorSortFunction)" class="d-none d-md-table-cell curpoint" matRipple>
                                <div class="d-flex">
                                    Inspecteur
                                    <app-sorting-icon [currentSort]="currentSort()" [desc]="desc()" [property]="inspectorSortFunction" class="ms-1"></app-sorting-icon>
                                </div>
                            </th>
                            <th (click)="sortList('created_at')" class="curpoint" matRipple>
                                <div class="d-flex">
                                    Datum
                                    <app-sorting-icon [currentSort]="currentSort()" [desc]="desc()" class="ms-1" property="created_at"></app-sorting-icon>
                                </div>
                            </th>
                            @if (AuthorisationService.hasFeature('checklistAnswerDelete')) {
                                <th class="trash-column">
                                </th>
                            }
                        </tr>
                    </thead>
                    <tbody>

                        @for (checklist of list(); track checklist.id) {
                            <tr [queryParams]="{completedId: checklist.id}" class="curpoint" routerLink="/{{Routenames.checklistFillIn}}/{{checklist.checklist_id}}">
                                <td>
                                    {{checklist.checklist.name}} <b>{{checklist.final ? '' : '(concept)'}}</b>
                                </td>
                                <td>
                                    {{checklist.worknumber}}
                                </td>
                                <td class="d-none d-md-table-cell">
                                    {{checklist.foreman?.name}}
                                </td>
                                <td class="d-none d-md-table-cell">
                                    {{checklist.inspector?.name}}
                                </td>
                                <td class="d-none d-md-table-cell">
                                    {{checklist.created_at | date  : 'd MMM yyyy, H:mm'}}
                                </td>
                                <td class="d-md-none">
                                    {{checklist.created_at | date  : 'd MMM'}}
                                </td>
                                @if (AuthorisationService.hasFeature('checklistAnswerDelete')) {
                                    <td>
                                        @if (!checklist.final) {
                                            <button (click)="delete($event, checklist)" color="warn" mat-icon-button>
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        }
                                    </td>
                                }
                            </tr>
                        } @empty {
                            <tr>
                                <td colspan="99">
                                    Geen inspecties gevonden
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
